export default "__VITE_ASSET__B$88RlAy__"